export const containsQueryString = (url: string) => /\?/.test(url);

export const generateQueryStrings = (
  params: Array<{ key: string; value: string }>,
): string =>
  params
    .filter((param) => param.value !== '')
    .map(
      (param) =>
        `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`,
    )
    .join('&');
